import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const EmployerSettings = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    companyName: 'TechCorp Solutions Pvt Ltd',
    companyWebsite: 'https://techcorp.in',
    companySize: '50-200 employees',
    industry: 'Information Technology',
    companyLogo: "https://images.unsplash.com/photo-1678307882102-9750b50c3d82",
    recruiterName: 'Rajesh Kumar',
    recruiterTitle: 'Senior HR Manager'
  });

  const [subscription] = useState({
    plan: 'Professional',
    status: 'Active',
    nextBilling: '27/12/2025',
    amount: '₹4,999',
    jobPostsRemaining: 15,
    featuredPostsRemaining: 3
  });

  const [billingHistory] = useState([
  {
    id: 1,
    date: '27/10/2025',
    description: 'Professional Plan - Monthly',
    amount: '₹4,999',
    status: 'Paid',
    invoice: 'INV-2025-1027'
  },
  {
    id: 2,
    date: '27/09/2025',
    description: 'Professional Plan - Monthly',
    amount: '₹4,999',
    status: 'Paid',
    invoice: 'INV-2025-0927'
  },
  {
    id: 3,
    date: '27/08/2025',
    description: 'Professional Plan - Monthly',
    amount: '₹4,999',
    status: 'Paid',
    invoice: 'INV-2025-0827'
  }]
  );

  const handleSave = () => {
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  return (
    <div className="space-y-6">
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Building2" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Company Information</h2>
              <p className="text-sm text-muted-foreground">Update your company details and branding</p>
            </div>
          </div>
          {!isEditing &&
          <Button
            variant="outline"
            size="sm"
            iconName="Edit2"
            iconPosition="left"
            onClick={() => setIsEditing(true)}>

              Edit
            </Button>
          }
        </div>

        <div className="space-y-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
            <div className="relative">
              <div className="w-24 h-24 rounded-lg overflow-hidden border-2 border-border bg-muted">
                <Image
                  src={formData?.companyLogo}
                  alt="Modern corporate office building with glass facade and company branding visible on entrance"
                  className="w-full h-full object-cover" />

              </div>
              {isEditing &&
              <button className="absolute bottom-0 right-0 w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center hover:bg-primary/90 transition-smooth">
                  <Icon name="Camera" size={16} />
                </button>
              }
            </div>
            <div className="flex-1">
              <h3 className="text-sm font-medium text-foreground mb-1">Company Logo</h3>
              <p className="text-xs text-muted-foreground mb-3">PNG or SVG. Max size 2MB. Recommended 400x400px</p>
              {isEditing &&
              <div className="flex flex-wrap gap-2">
                  <Button variant="outline" size="sm" iconName="Upload">
                    Upload New
                  </Button>
                  <Button variant="ghost" size="sm" iconName="Trash2">
                    Remove
                  </Button>
                </div>
              }
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Company Name"
              type="text"
              value={formData?.companyName}
              onChange={(e) => setFormData((prev) => ({ ...prev, companyName: e?.target?.value }))}
              disabled={!isEditing}
              required />


            <Input
              label="Company Website"
              type="url"
              value={formData?.companyWebsite}
              onChange={(e) => setFormData((prev) => ({ ...prev, companyWebsite: e?.target?.value }))}
              disabled={!isEditing}
              placeholder="https://example.com" />


            <Input
              label="Company Size"
              type="text"
              value={formData?.companySize}
              onChange={(e) => setFormData((prev) => ({ ...prev, companySize: e?.target?.value }))}
              disabled={!isEditing} />


            <Input
              label="Industry"
              type="text"
              value={formData?.industry}
              onChange={(e) => setFormData((prev) => ({ ...prev, industry: e?.target?.value }))}
              disabled={!isEditing} />


            <Input
              label="Recruiter Name"
              type="text"
              value={formData?.recruiterName}
              onChange={(e) => setFormData((prev) => ({ ...prev, recruiterName: e?.target?.value }))}
              disabled={!isEditing} />


            <Input
              label="Recruiter Title"
              type="text"
              value={formData?.recruiterTitle}
              onChange={(e) => setFormData((prev) => ({ ...prev, recruiterTitle: e?.target?.value }))}
              disabled={!isEditing} />

          </div>

          {isEditing &&
          <div className="flex flex-wrap gap-3 pt-4 border-t border-border">
              <Button
              variant="default"
              iconName="Check"
              iconPosition="left"
              onClick={handleSave}>

                Save Changes
              </Button>
              <Button
              variant="outline"
              iconName="X"
              iconPosition="left"
              onClick={handleCancel}>

                Cancel
              </Button>
            </div>
          }
        </div>
      </div>
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="CreditCard" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Subscription Management</h2>
            <p className="text-sm text-muted-foreground">Manage your plan and billing information</p>
          </div>
        </div>

        <div className="space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="p-4 bg-muted rounded-lg">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Package" size={16} className="text-primary" />
                <p className="text-xs font-medium text-muted-foreground">Current Plan</p>
              </div>
              <p className="text-lg font-semibold text-foreground">{subscription?.plan}</p>
              <p className="text-xs text-success mt-1">{subscription?.status}</p>
            </div>

            <div className="p-4 bg-muted rounded-lg">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Calendar" size={16} className="text-primary" />
                <p className="text-xs font-medium text-muted-foreground">Next Billing</p>
              </div>
              <p className="text-lg font-semibold text-foreground">{subscription?.nextBilling}</p>
              <p className="text-xs text-muted-foreground mt-1">{subscription?.amount}/month</p>
            </div>

            <div className="p-4 bg-muted rounded-lg">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="FileText" size={16} className="text-primary" />
                <p className="text-xs font-medium text-muted-foreground">Job Posts</p>
              </div>
              <p className="text-lg font-semibold text-foreground">{subscription?.jobPostsRemaining}</p>
              <p className="text-xs text-muted-foreground mt-1">{subscription?.featuredPostsRemaining} featured remaining</p>
            </div>
          </div>

          <div className="flex flex-wrap gap-3">
            <Button variant="default" iconName="ArrowUpCircle" iconPosition="left">
              Upgrade Plan
            </Button>
            <Button variant="outline" iconName="Download" iconPosition="left">
              Download Invoice
            </Button>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground mb-4">Billing History</h3>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-border">
                    <th className="text-left py-3 px-4 text-xs font-medium text-muted-foreground">Date</th>
                    <th className="text-left py-3 px-4 text-xs font-medium text-muted-foreground">Description</th>
                    <th className="text-left py-3 px-4 text-xs font-medium text-muted-foreground">Amount</th>
                    <th className="text-left py-3 px-4 text-xs font-medium text-muted-foreground">Status</th>
                    <th className="text-left py-3 px-4 text-xs font-medium text-muted-foreground">Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  {billingHistory?.map((item) =>
                  <tr key={item?.id} className="border-b border-border last:border-0">
                      <td className="py-3 px-4 text-sm text-foreground">{item?.date}</td>
                      <td className="py-3 px-4 text-sm text-foreground">{item?.description}</td>
                      <td className="py-3 px-4 text-sm font-medium text-foreground">{item?.amount}</td>
                      <td className="py-3 px-4">
                        <span className="px-2 py-1 bg-success/10 text-success text-xs font-medium rounded">
                          {item?.status}
                        </span>
                      </td>
                      <td className="py-3 px-4">
                        <button className="text-sm text-primary hover:underline">
                          {item?.invoice}
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>);

};

export default EmployerSettings;